/* eslint-disable max-len */
export const TESTIMONIALS = [
  {
    key: '01',
    name: 'Priyank Saxena',
    designation: 'Software Developer',
    testimony:
    "Been using Yodaa to transfer pocket money to my 14 year old daughter for the past month. It's a huge improvement over using payment wallets and cash. Recommended",
    apple: false,
    image:
    'https://assets.website-files.com/5ff43bfe2aa4e5ff56a3e60d/603aa68ce4f2733f0f43f0b8_Group%203921.png',
  },
  {
    key: '04',
    name: 'Ruchi Kumar',
    designation: 'Student',
    testimony:
      "Not having to ask my parents for money is a huge relief. I also don't have to explain what I'm spending on as they get all the information they need on the app.",
    apple: true,
    image:
      'https://assets.website-files.com/5ff43bfe2aa4e5ff56a3e60d/603aaa076827ad5f191e79b5_Group%203921.png',
  },
  {
    key: '02',
    name: 'Dhruv Menon',
    designation: 'Student',
    testimony:
      "It feels nice to be able to pull out my own card and pay when I'm out with friends. I also love the way the card looks so sleek and minimal. ♥",
    apple: false,
    image:
      'https://assets.website-files.com/5ff43bfe2aa4e5ff56a3e60d/603b81534e593194b9b62bf1_Group%203921.png',
    },
    {
      key: '05',
      name: 'Nimisha K',
      designation: 'Product Manager',
      testimony:
        "Yodaa's rich feature set is a godsend for parents looking to incentivize teens in the right ways. My son is now interested in how savings and investments work.I feel Yodaa is definitely worth it.",
      apple: true,
      image:
        'https://assets.website-files.com/5ff43bfe2aa4e5ff56a3e60d/603b7be7fa052d25382fd190_Group%203921.png',
    },
  {
    key: '03',
    name: 'Mehak Kaur',
    designation: 'Homemaker',
    testimony:
      'I was looking for an efficient way to manage money transfers to my teens and have them participate in the digital economy. Yodaa is a great step towards this. Looking forward to future features.',
    apple: false,
    image:
      'https://assets.website-files.com/5ff43bfe2aa4e5ff56a3e60d/603aa6d45dc3e98202720ab7_Group%203921.png',
  },
  {
    key: '06',
    name: 'Joseph J',
    designation: 'Student',
    testimony:
      'I was excited about getting a cool card but the Yodaa app was a huge surprise. I end up listening to the recommended podcasts while travelling and making wealth projections based on the insights!',
    apple: true,
    image:
      'https://assets.website-files.com/5ff43bfe2aa4e5ff56a3e60d/603aab4a93f850c7316d3a77_Group%203921.png',
  },
];
